import { render, staticRenderFns } from "./linkanchor.vue?vue&type=template&id=74b9c0f3&"
import script from "./linkanchor.vue?vue&type=script&lang=js&"
export * from "./linkanchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports